import { Component } from '@angular/core';

@Component({
    selector: 'app-licencas-esgotadas',
    templateUrl: './licencas-esgotadas.component.html',
    styleUrls: ['./licencas-esgotadas.component.scss']
})
export class LicencasEsgotadasComponent {}
